import { Redirect } from 'react-router-dom';
import { Card, CardBody, Container } from 'reactstrap';
import CommonHeader from '../components/Headers/CommonHeader';
import AdminDashboard from '../components/Dashboards/AdminDashboard';
import ParentDashboard from '../components/Dashboards/ParentDashboard';
import StaffDashboard from '../components/Dashboards/StaffDashboard';
import ClassroomDashboard from '../components/Dashboards/ClassroomDashboard';
import LoaderSpinner from '../components/Core/LoaderSpinner';

import isAdmin from '../helpers/isAdmin';
import { useContext } from 'react';

import { Context as AuthContext } from '../contexts/AuthContext';
import isParent from '../helpers/isParent';
import isStaff from '../helpers/isStaff';
import isClassroom from '../helpers/isClassroom';
import isTeacher from '../helpers/isTeacher';
import isDirector from '../helpers/isDirector';
import isEducationDirectorAdminAssistant from '../helpers/isEducationDirectorAdminAssistant';
import isUpperManagement from '../helpers/isUpperManagement';
import isFranchiseeManagment from '../helpers/isFranchiseeManagment';
import hrHomePath from '../helpers/hrHomePath';

const Home = (_: any) => {
  const { user, childcareEnabled, childcareResolved }: any = useContext(AuthContext);
  const hrHome = hrHomePath(user);
  const childcareOnlyUser = isParent(user) || isClassroom(user);

  if ((hrHome || childcareOnlyUser) && !childcareResolved) {
    return <LoaderSpinner />;
  }

  if (hrHome && !childcareEnabled) {
    return <Redirect to={hrHome} />;
  }

  return (
    <>
      {!isClassroom(user) && <CommonHeader />}
      {(isDirector(user) ||
        isAdmin(user) ||
        isEducationDirectorAdminAssistant(user) ||
        isUpperManagement(user) ||
        isFranchiseeManagment(user)) && <AdminDashboard />}
      {isParent(user) && childcareEnabled && <ParentDashboard currentUser={user} />}
      {(isStaff(user) || isTeacher(user)) && <StaffDashboard currentUser={user} />}
      {isClassroom(user) && childcareEnabled && <ClassroomDashboard currentUser={user} />}
      {childcareOnlyUser && !childcareEnabled && (
        <Container className={isClassroom(user) ? 'mt-5' : 'mt--7'} fluid>
          <Card className="shadow">
            <CardBody className="text-center">Childcare is not enabled for this school.</CardBody>
          </Card>
        </Container>
      )}
    </>
  );
};

export default Home;
